(function() {

    angular.module('ApplicationsProvider', [])
    
    .factory('ApplicationModel',
    ['$q', '$http', 'TenantListService', 'Utils',
    function( $q, $http, TenantListService, Utils) {
        return function(data) {
            var ApplicationModel = {
                info: setData(data),
                tenantId: TenantListService.currentTenant.customProperties.id,
                secretClearText: false,
                id: data._links.self.href.split('/').pop(),
                options: {
                    isSelected: false
                }
            };

            function setData (data) {
                var info = data
                return info
            }


            ApplicationModel.update = (applicationOriginal, applicationModified) => {
                var deferred = $q.defer();
                var url = ApplicationModel.info._links.self.href;
                var patch = Utils.getObjectsDifferencesForPatching(applicationOriginal.info, applicationModified.info);
                $http.patch(url, patch).then((response) => {
                    ApplicationModel.info = setData(response.data);
                    deferred.resolve(response);
                }).catch(function(error){
                    deferred.reject(error);
                    console.log('error', error);
                });
                return deferred.promise;
            };

            ApplicationModel.delete = () => {
                var deferred = $q.defer();
                var url = ApplicationModel.info._links.self.href;
                $http.delete(url).then((response) => {
                    deferred.resolve(response);
                }).catch(function(error){
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            ApplicationModel.rotateSecret = () => {
                var deferred = $q.defer();
                var url = ApplicationModel.info._links["px:rotateClientSecret"].href;
                $http.post(url).then((response) => {
                    ApplicationModel.info = setData(response.data);
                    ApplicationModel.secretClearText = true;
                    deferred.resolve(ApplicationModel);
                }).catch(function(error){
                    console.log('error', error);
                    deferred.reject(error);
                });
                return deferred.promise
            }

            return ApplicationModel;
        }
        }])
    
        .service('ApplicationsService', [
            '$http', '$q', 'TenantListService', 'ApplicationModel',
        function(
            $http, $q, TenantListService, ApplicationModel
        ) {
            
            this.getPage = () => {
                const deferred = $q.defer();
                const url = TenantListService.currentTenant.info._links["px:oauthclients"].href;
                $http.get(url).then((response) => {
                    const listObject = {
                        list: []
                    };
                    if (response.data._embedded) {
                        response.data._embedded['px:oAuth2ClientInformationResources'].forEach((application) => {
                            listObject.list.push(new ApplicationModel(application));
                        })
                    }

                    listObject.list.sort((a, b) => {
                        const nameA = a.info.name
                        const nameB = b.info.name
                        return nameA.localeCompare(nameB);
                    });

                    deferred.resolve(listObject);
                }).catch(function(error){
                    deferred.reject(error);
                });

                return deferred.promise;
            }

            this.create = (application) => {
                const deferred = $q.defer();
                const url = TenantListService.currentTenant.info._links["px:oauthclients"].href;
                $http.post(url, application).then((response) => {
                    deferred.resolve(new ApplicationModel(response.data));
                }).catch(function(error){
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            this.delete = (applications, callback) => {
                const deferred = $q.defer();
                const deletePromises = applications.map(application => {
                    return application.delete();
                });


                $q.all(deletePromises).then((results) => {
                    callback();
                    deferred.resolve(results);
                }).catch((error) => {
                    deferred.reject(error);
                });
                return deferred.promise;
            }
    
        }
    ])

})();